import http from "@/http-common"

class LocalDiffuserDataService {
  getLocalDiffuserSolicitations(localDiffuserId: number): Promise<any> {
    return http.get(`/auth/local-diffusers/solicitations/${localDiffuserId}`)
  }

  getDialogueSolicitations(tourismInformationCenterId: number): Promise<any> {
    return http.get(`/auth/local-diffusers/dialogue-solicitations/${tourismInformationCenterId}`)
  }

  getLocalDiffuserLogo(establishmentId: number, headers: {}): Promise<any> {
    return http.get(`/auth/local-diffusers/logo/${establishmentId}`, { headers: headers })
  }

  getLocalDiffuserStatus(establishmentId: number): Promise<any> {
    return http.get(`/auth/establishments/${establishmentId}/open-form/last-state`)
  }

  refuseAdhesion(solicitationId: number): Promise<any> {
    return http.post(`/auth/local-diffusers/solicitations/refuse-adhesion`, { solicitation_id: solicitationId })
  }
}

export default new LocalDiffuserDataService()
